import React, { PropTypes, Component } from 'react';
import Helmet from 'react-helmet';

import Header from './Header';
import Footer from './Footer';
import Loading from './Loading';
// import Breadcrumb from './Breadcrumb';

const {
    APP_NAME
} = require('../core/constants').default;

class AppComponent extends Component {
    componentDidMount() {
        const { actions } = this.props;

        // check session token
        actions.sessionTokenRequest();

        // check session token
        actions.getAppBrandRequest();
    }

    isSlimLayout() {
        const { location } = this.props;
        return location.pathname.indexOf('resources/view') === 0 || location.pathname.indexOf('/resources/view') === 0;
    }

    render() {
        const { children, rehydrationCompleted, profile, actions, brand } = this.props;

        // wait until rehydration is completed by redux from local storage
        if (!rehydrationCompleted) {
            return <Loading />;
        }

        const helmet = (
            <Helmet
                title="App"
                titleTemplate={`%s - ${APP_NAME}`}
                defaultTitle={`${APP_NAME}`}
                meta={[
                    { name: 'description', content: `${APP_NAME} website` },
                    { property: 'og:type', content: 'website' }
                ]} />
        );

        return (
            <div id="app" className={this.isSlimLayout() ? 'slim-layout' : 'normal-layout'}>
                {helmet}
                <Header profile={profile} brand={brand} actions={actions} />
                { children }
                {!this.isSlimLayout() ? <Footer profile={profile} brand={brand} /> : null}
            </div>
        );
    }
}

AppComponent.propTypes = {
    rehydrationCompleted: PropTypes.bool,
    // breadcrumb: PropTypes.array,
    children: PropTypes.element,
    actions: PropTypes.object,
    profile: PropTypes.object,
    location: PropTypes.object,
    brand: PropTypes.object,
};

export default AppComponent;



/** WEBPACK FOOTER **
 ** ./src/components/AppComponent.js
 **/